// @ts-nocheck
if (!window.videoObserver) {
  window.videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < 0.5 && !entry.target.paused) {
          entry.target.pause()
        } else if (entry.intersectionRatio >= 0.5 && entry.target.paused) {
          let source = entry.target.querySelector('source')
          if (!source) {
            const srcs = JSON.parse(entry.target.getAttribute('data-srcs') || '[]')
            srcs.forEach((src) => {
              source = document.createElement('source')
              source.setAttribute('type', src.type)
              source.setAttribute('src', src.src)
              entry.target.appendChild(source)
              entry.target.classList.remove('blur-sm')
            })
          }
          const $splideSlide = entry.target.closest('.splide__slide')
          if ($splideSlide) {
            entry.target.pause()
          } else {
            entry.target.play()
          }

          // GA tracking for video play
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'videoPlay',
            videoName:
              entry.target.getAttribute('alt') ||
              [...entry.target.querySelectorAll('source')]?.at(-1)?.getAttribute('src') ||
              'Unnamed video',
          })
        }
      })
    },
    { threshold: [0.1, 0.25, 0.5, 0.75, 0.9] }
  )
}

const $$videos = document.querySelectorAll('[data-lazy-video]')
$$videos.forEach(($video) => window.videoObserver.observe($video))
